// 当一个组件中有多个export的项，可以导出为*
import * as auth from "auth-provider";
import { FullPageErrorFallback, FullPageLoading } from "components/lib";
import { default as React, ReactNode, useCallback, useState } from "react";
import {
  APP_API_URL,
  DEVICE_TYPE_KEY,
  PROJECT_CLIENT_ID,
  useMount,
} from "screens/register/util";
import { http, getErrorMsg, CHOWBUS_API_URL, CHOWBUS_MONOLITH_API_URL } from "utils/http";
import { useAsync } from "utils/use-async";
import qs from "qs";
import {
  InitWebLogger,
  MIX_PANEL_EVENT,
  trackMixPanel,
} from "mixpanel/mixpanelTrackUtil";
import { getBrowserType } from "utils";
import { DealType, LoyaltyContractSetting, ONLINE_PAYMENT_CHANNEL, RechargeDeal, RestaurangGroup, RestaurantGroupContract, RestaurantInfo, RestaurantLoyaltySetting } from "types/loyalty";
import { JoinMemberMode } from "types/joinAsMemberMode";

const lang = auth.getLanguage();


const bootstrapRestaurant = async (
  restaurantCode: string,
  onboardingForTwilio: boolean,
) => {
  let restaurant_id = "";
  let isEnableLanguageSwitch = true;
  let enableLoyaltyMemberRegister = true;
  let restaurant = null;
  let configCenterPreference = null;
  let restaurantLoyaltyInfo: RestaurantLoyaltySetting = {
    restaurangGroup: null,
    loyaltyContractSetting: null,
    prepaidDealList: [],
    annualDeal: null,
  }
  try {
    const [restaurantIdRes, configCenterPreferenceData] = await Promise.all([http(
      `${APP_API_URL}/api/${lang}/v1/restaurant_settings/fetch_by_code`,
      {
        method: "get",
        params: { code: restaurantCode },
        headers: {
          "client-id": PROJECT_CLIENT_ID,
        },
      }
    ),
    http(
      `${CHOWBUS_MONOLITH_API_URL}/config-center/resolve/loyalty-web`,
      {
        method: "get",
        headers: {
          "client-id": PROJECT_CLIENT_ID,
        },
      }
    )
    ],
    );

    let data = restaurantIdRes?.data;
    if (data && data.attributes) {
      restaurant_id = data.attributes?.restaurant_id;
      isEnableLanguageSwitch = data.attributes?.show_language_switch;
      enableLoyaltyMemberRegister = data.attributes?.enable_register;
      if (enableLoyaltyMemberRegister === undefined) {
        enableLoyaltyMemberRegister = true;
      }

      if (isEnableLanguageSwitch === undefined) {
        isEnableLanguageSwitch = true;
      }

      // 没有获取到餐厅id
      if (!restaurant_id) {
        return null;
      }

      //load restaruant detail
      try {
        restaurant = await http(
          `${APP_API_URL}/api/v1/proxy_restaurants/${restaurant_id}`,
          {
            params: {
              "_t": new Date().getTime(),
            },
            headers: {
              "client-id": PROJECT_CLIENT_ID,
            },
          }
        );

        if (restaurant?.data?.attributes?.loyalty_web_version === "v2") {
          let path = ''
          if (process.env.REACT_APP_V2_URL) {
            path = `${process.env.REACT_APP_V2_URL}/${restaurantCode}/landing`;
          } else {
            path = `${window.location.origin}/v2/${restaurantCode}/landing`;
          }
          window.location.replace(path);
          return new Promise<{ restaurant: any; restaurantLoyaltyInfo: RestaurantLoyaltySetting; } | null>(() => { });
        }
      } catch (error) {
        const errorMsg = getErrorMsg(error);
        trackMixPanel(MIX_PANEL_EVENT.HOME_PAGE_RESTAURANT_ID_ERROR, {
          errorMsg,
          errorApi: "api/v1/proxy_restaurants/{restaurant_id}",
        });
      }


      try {
        const restaurant_groups_ = await http(
          `${CHOWBUS_API_URL}/api/${lang}/restaurant_group/v1/restaurant_groups`,
          {
            method: "get",
            params: {
              "restaurant_id": restaurant_id,
            },
            headers: {
              "client-id": PROJECT_CLIENT_ID,
            },
          }
        );
        if (restaurant_groups_.data && restaurant_groups_.data.id) {
          restaurantLoyaltyInfo.restaurangGroup = {
            id: restaurant_groups_.data.id,
            includRestaurantList: [],
            groupContract: null,
          };
        }
      } catch (error) {
      }
      //check if  restaurant group and loyalty is actived
      if (restaurantLoyaltyInfo.restaurangGroup && restaurantLoyaltyInfo.restaurangGroup.id) {
        try {
          const getRestaurantGroupInfo = await http(
            `${CHOWBUS_API_URL}/wallet/api/gift_card/restaurant_group/deal_contracts/query_by_use_scope`,
            {
              method: "get",
              params: {
                "scope_resource_type": 'Restaurant',
                "scope_resource_ref": restaurant_id,
                "distribution_mode": 'loyalty'
              },
              headers: {
                "client-id": PROJECT_CLIENT_ID,
              },
            }
          );

          let includedDealContract = getRestaurantGroupInfo?.included;
          let _restaurantGroupContractInfo_ = getRestaurantGroupInfo?.data[0];
          let restaurantGroupContractInfo: RestaurantGroupContract | null = null;
          if (_restaurantGroupContractInfo_) {
            let { commission_rate, currency, description, gift_card_is_active, is_active, name, vendor_id, vendor_type } = _restaurantGroupContractInfo_.attributes;
            restaurantGroupContractInfo = {
              id: _restaurantGroupContractInfo_.id,
              commission_rate: commission_rate,
              currency,
              description: description || '',
              gift_card_is_active,
              is_active,
              name,
              vendor_id,
              vendor_type,
            };
          }

          let restaurantsInRestaurantGroup = (getRestaurantGroupInfo?.meta?.restaurants || []).map((item: any) => {
            let { foreign_name, name, id, language, logo_url, phone_number, restaurant_group_id, service_region_id,
              address: {
                address1,
                address2,
                city, country, delivery_zone_id, latitude, longitude, state, zip_code
              } } = item;
            let restaurantInfo: RestaurantInfo = {
              name,
              foreign_name,
              id,
              logo_url,
              language,
              phone_number,
              restaurant_group_id,
              service_region_id,
              address: {
                address1: address1 || '',
                address2: address2 || '',
                city, country, delivery_zone_id, latitude, longitude, state, zip_code
              }
            }
            return restaurantInfo;
          })
          let restaurantGroupInfo = includedDealContract.reduce((result: {
            loyaltyContractSetting: LoyaltyContractSetting;
            prepaidDealList: RechargeDeal[];
            annualDeal: RechargeDeal;
          }, dealContract: any) => {
            if (dealContract.type === "deal_contract_setting") {
              result.loyaltyContractSetting = { ...dealContract.attributes, enable_register: enableLoyaltyMemberRegister };

            } else if (dealContract.type === "deal") {
              let dealId = dealContract.id;
              let {
                deal_type,//:  "annual_fee" / "prepaid"
              } = dealContract.attributes;
              if (deal_type === 'annual_fee') {
                try {
                  if (dealContract.attributes["annual_amount"] && Number.parseFloat(dealContract.attributes["annual_amount"]) > 0) {
                    result.annualDeal = {
                      id: dealId,
                      ...dealContract.attributes
                    };
                  }
                } catch (e) { }

              } else if (deal_type === 'prepaid') {
                try {
                  if (dealContract.attributes["cash_amount"] && Number.parseFloat(dealContract.attributes["cash_amount"]) > 0) {
                    result.prepaidDealList.push({
                      id: dealId,
                      ...dealContract.attributes
                    });
                  }
                } catch (e) { }

              }
            }
            return result;
          }, {
            loyaltyContractSetting: null,
            prepaidDealList: [],
            annualDeal: null,
          });
          console.log('restaurantGroupInfo', restaurantGroupInfo);
          restaurantLoyaltyInfo.loyaltyContractSetting = restaurantGroupInfo.loyaltyContractSetting;
          restaurantLoyaltyInfo.prepaidDealList = restaurantGroupInfo.prepaidDealList;
          restaurantLoyaltyInfo.annualDeal = restaurantGroupInfo.annualDeal;
          restaurantLoyaltyInfo.restaurangGroup.includRestaurantList = restaurantsInRestaurantGroup;
          restaurantLoyaltyInfo.restaurangGroup.groupContract = restaurantGroupContractInfo || null;
          if (restaurantLoyaltyInfo.loyaltyContractSetting && restaurantGroupInfo.annualDeal) {
            restaurantLoyaltyInfo.loyaltyContractSetting = {
              ...restaurantLoyaltyInfo.loyaltyContractSetting,
              annual_fee_amount: restaurantGroupInfo.annualDeal.annual_amount,
              annual_fee_deal_id: restaurantGroupInfo.annualDeal.id,
            }

          }

        } catch (error) {
          //{"errors":[{"title":"deal_contract is not present."}]}
          //reset restaurangGroup info 
          restaurantLoyaltyInfo.restaurangGroup = null;
        }
      }

      if (!restaurantLoyaltyInfo.restaurangGroup || !restaurantLoyaltyInfo.restaurangGroup.id) {
        const restaurantLoyaltySettingDetailRes = await http(
          `${APP_API_URL}/api/${lang}/v1/restaurants/${restaurant_id}/restaurant_settings`,
          {
            method: "get",
            params: {},
            headers: {
              "client-id": PROJECT_CLIENT_ID,
            },
          }
        );
        data = restaurantLoyaltySettingDetailRes?.data;
        if (data && data.attributes) {
          let { annual_fee_deal_id, annual_fee_amount, cash_back_ratio, discount_ratio, join_member_mode, recharge_available_restrict_days, regular_member_for_days, new_member_for_days, photo_url, logo_url } = data.attributes;
          restaurantLoyaltyInfo.loyaltyContractSetting = {
            cash_back_ratio,//"0.05"
            // deal_contract_id: number;//: 2058
            discount_ratio,
            join_member_mode,//: "annual_fee_join","recharge_join","free_join"
            new_member_for_days,//: null
            recharge_available_restrict_days,
            regular_member_for_days,
            annual_fee_amount: annual_fee_amount,
            annual_fee_deal_id: annual_fee_deal_id,
            photo_url,
            logo_url,
            enable_register: enableLoyaltyMemberRegister,
          };
          if (join_member_mode === JoinMemberMode.annual_fee_join) {
            restaurantLoyaltyInfo.annualDeal = {
              id: annual_fee_deal_id,
              annual_amount: annual_fee_amount,
              bonus_amount: null,//: null / "10.0"
              cash_amount: null,//: null / "100.0"
              deal_type: DealType.annual_fee,//:  "annual_fee" / "prepaid"
              foreign_name: `年费${annual_fee_amount}`,//: "年费$10" /  "充值$100, 送$10"
              name: `Annual fee ${annual_fee_amount}`,//: "Annual fee $10" / "Pay $100, Get $10"
            }
          }
        }


        const restaurantLoyaltyRechargeListRes = await http(
          `${CHOWBUS_API_URL}/wallet/api/gift_card/v1/deals`,
          {
            method: "get",
            params: {
              vendor_id: restaurant_id,
              vendor_type: "Restaurant",
            },
            headers: {
              "client-id": PROJECT_CLIENT_ID,
            },
          }
        );

        if (!Array.isArray(restaurantLoyaltyRechargeListRes.data) || !restaurantLoyaltyRechargeListRes.data.length) {
          restaurantLoyaltyInfo.prepaidDealList = [];
        } else {
          restaurantLoyaltyInfo.prepaidDealList = restaurantLoyaltyRechargeListRes.data.filter((item: any) => {
            let { attributes: { cash_amount } } = item;
            if (cash_amount && Number.parseFloat(cash_amount) > 0) {
              return true;
            }
            return false;
          }).map((item: any) => {
            let { id, attributes: { annual_amount, bonus_amount, cash_amount, foreign_name, name } } = item;
            return {
              id,
              annual_amount,//: "10.0"
              bonus_amount,//: null / "10.0"
              cash_amount,//: null / "100.0"
              deal_type: DealType.prepaid,//:  "annual_fee" / "prepaid"
              foreign_name,//: "年费$10" /  "充值$100, 送$10"
              name,//: "Annual fee $10" / "Pay $100, Get $10"
            }
          });
        }

      }
    }

    configCenterPreference = configCenterPreferenceData?.data;

  } catch (error) {
    const errorMsg = getErrorMsg(error);
    trackMixPanel(MIX_PANEL_EVENT.HOME_PAGE_FETCH_CODE_ERROR, {
      errorMsg,
      errorApi: "api/{lang}/v1/restaurant_settings/fetch_by_code",
      restaurantCode,
    });
  }
  // 没有获取到餐厅id
  if (!restaurant_id) {
    return null;
  }

  restaurant.configCenterPreference = configCenterPreference;
  restaurant.isEnableLanguageSwitch = isEnableLanguageSwitch;
  //餐厅设置的online payment支付通道
  //::ADYEN::
  restaurant.payment_channel_code = restaurant.data.attributes.payment_channel_code || ONLINE_PAYMENT_CHANNEL.Stripe;
  //::ADYEN:: For Test
  // restaurant.payment_channel_code = 'adyen';
  auth.registerAuthCodeInfo(restaurant, onboardingForTwilio);
  // 存数据
  return {
    restaurant,
    restaurantLoyaltyInfo
  };
};

const AuthContext = React.createContext<
  | {
    restaurant: any;
    getLanguage: () => string;
    isValidLink: Boolean;
    restaurantCode: string | undefined;
    disountData: LoyaltyContractSetting | null;
    restaurantLoyaltySetting: RestaurantLoyaltySetting | null;
    restaurantGroupInfo: RestaurangGroup | null;
  }
  | undefined
>(undefined);
AuthContext.displayName = "AuthContext";

// 一层一层包裹，向上传递，AuthProvider -> AppProvider -> 顶层index.tsx，这样确保了页面在渲染时，就会执行此处AuthProvider方法体中定义的方法
export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const {
    data: initResult,
    error,
    isLoading,
    isIdle,
    isError,
    run,
  } = useAsync<{
    restaurant: any;
    restaurantLoyaltyInfo: RestaurantLoyaltySetting;
  } | null>();

  InitWebLogger(process.env.REACT_APP_WEB_LOG_KEY || "");
  const getLanguage = auth.getLanguage;
  const [isValidLink, setIsValidLink] = useState(true);
  // 声明为响应式变量，其他组件才能取到
  const [restaurantCode, setRestaurantCode] = useState<string | undefined>(
    undefined
  );

  // 整个App加载的时候，去获取用户数据
  useMount(
    useCallback(() => {
      const [, searchStr] = window.location.search.split("?");
      const searchParamObj = qs.parse(searchStr);
      // 有code的链接才是正常的
      const code = searchParamObj.code as string | undefined;
      const onboardingForTwilio = (searchParamObj.onboarding as string | undefined) === 'true' ? true : false;
      if (code) {
        setIsValidLink(true);
        localStorage.setItem(DEVICE_TYPE_KEY, getBrowserType().osName);
        setRestaurantCode(code);
        run(bootstrapRestaurant(code || "", onboardingForTwilio));
      } else {
        setIsValidLink(false);
        trackMixPanel(MIX_PANEL_EVENT.HOME_PAGE_CODE_INVALID);
      }
    }, [run])
  );

  if ((isIdle || isLoading) && isValidLink) {
    return <FullPageLoading></FullPageLoading>;
  }

  if (isError) {
    return <FullPageErrorFallback error={error} />;
  }

  return (
    <AuthContext.Provider
      children={children}
      value={{
        restaurant: initResult ? initResult.restaurant : null,
        getLanguage,
        isValidLink,
        restaurantCode,
        restaurantLoyaltySetting: initResult ? initResult.restaurantLoyaltyInfo : null,
        disountData: initResult ? initResult.restaurantLoyaltyInfo.loyaltyContractSetting : null,
        restaurantGroupInfo: initResult ? initResult.restaurantLoyaltyInfo.restaurangGroup : null,
      }}
    />
  );
};

// 其他组件要访问login等，直接通过调用useAuth()访问
export const useAuth = () => {
  const context = React.useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth必须在AuthProvider中使用");
  }
  return context;
};
